function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/recompose/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 190
// module chunks = 0